import { Injectable, EventEmitter, Output } from '@angular/core';
import {
    DocumentService,
    IvCertCircuitDocumentP,
    IvGenericRestResponseListIvCertCircuitDocumentP,
    IvGenericRestResponseString,
    Metadata,
    MetadataKeyOperationF,
    OperationDetailR,
    OperationService,
} from '../../../app/api';
import { IvCertGenericResponseListMetadataKeyOperationF } from '../../api/model/ivCertGenericResponseListMetadataKeyOperationF';
import { IvCertGenericResponseOperationDetailR } from '../../api/model/ivCertGenericResponseOperationDetailR';
import { AvailableOperationTypes } from '../models/operations/available-operation-types';
import { OperationRequest } from '../models/operations/operation-request';
import { AuthorizationStrategyService } from './authorization-strategy.service';
import { ProfileService } from '../../core/profile/profile.service';
import { AvailableOperationStatus } from '../models/operations/available-operation-status';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { IvCertGenericResponseListAuthPreference } from '../../api/model/ivCertGenericResponseListAuthPreference';
import { AuthPreference } from '../../api/model/authPreference';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CustomMetadataOperation, OperationCustomMetadata } from '../models/operations/metadata';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from 'file-saver';
import { DocumentListObserve } from '../models/operations/document-list-observe';
import { StatusBarModel } from '../models/status-bar/status-bar';
import * as FileSaver from 'file-saver';
import { IvCertGenericResponseListString } from '../../api/model/ivCertGenericResponseListString';
import { InternalMessage } from '../../api/model/internalMessage';
import { Extension, UploadConfig } from '../../models/types';
import { operationTypeEnum } from '../../models/operation-type';
import { Router } from '@angular/router';
import { EncodeB64Service } from '../../base/services/encode-b64/encode-b64.service';
import { OptionsGenericType } from '../../models/interfaces';

type OptDocumentProps = { b64?: string, read?: boolean };
type DocumentCircuit = Array<IvCertCircuitDocumentP & OptDocumentProps>;

@Injectable()
export class FinishProService {
    public operationRequest: OperationRequest;
    public authToken: string = '';
    public operationId: string;
    public circuitId: string;
    public hasNextOperation: boolean;
    public isPublic: boolean = false;
    public operationDetailResponse: OperationDetailR;
    public metadataResponse: Array<OperationCustomMetadata>;
    public documentListResponse: IvCertCircuitDocumentP[];
    public downloadDocumentResponse: any;
    public authPreferenceResponse: AuthPreference[];
    public nextOperationResponse: IvGenericRestResponseString;
    public finishOperationResponse: string[];
    public documentBuffer: Uint8Array;
    public documentIdSelected: string;
    public showNewOperationLoader: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public showProLoader: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public metadataOTP: Metadata;
    public statusBarModel: StatusBarModel;
    public FINISH_PRO_ROUTE = 'finishProOperation';
    public FINISH_ROUTE = 'finishOperation';
    public customCheckbox: EventEmitter<boolean> = new EventEmitter(false);
    public readAllDoc: number = 0;
    public validateFormDoc: number = 0;
    public xml: string = '';
    public extension: string = '';
    public validatorDocumentList: IvCertCircuitDocumentP[] = [];
    public idCircuitCorto: number;
    public extraDocs: IvCertCircuitDocumentP[];
    public mainDocs: IvCertCircuitDocumentP[];
    public hasCustomFields: boolean = false;
    public isProcessStarted: boolean;
    public documentsReaded: { idDocument: string, readed: boolean, loaded: boolean }[] = [];
    public otpCode: string;
    public receiverNIF: string;
    public internalMessages: Array<InternalMessage>;
    @Output() errorEvent = new EventEmitter();
    public ownerId: number;
    public receiverId: string;
    public letAttachment: boolean;
    public fileConfig: UploadConfig = {
        sizeTotal: 3670016,
        sizeDoc: 3670016,
        primaryMax: 5,
        secondaryMax: 5
    };
    public extensions: Extension = {
        primary: '.pdf,.PDF,.xml,.XML',
        primaryShort: '.pdf',
        secondary: '.pdf,.PDF',
        secondaryShort: '.pdf'
    };
    public attachedDocs: IvCertCircuitDocumentP[] = [];
    public userId: number;
    public customMessage: string;
    public isFinishPro: boolean;
    public urlCallbackOK: string;
    public urlCallbackKO: string;
    public tokenSAML: string;
    public isLocalSign: boolean = false;
    public documentsForSign: DocumentCircuit = [];
    public errorCodeRVDOTP = null;
    public termsAccepted: boolean = false;
    public pressureDeviceSigBio: boolean = false;
    public downloadOnFinish: boolean = false;
    public isDynSig: boolean = false;
    public metaDataOperation: OptionsGenericType[] = [];

    AUTH_KEY = 'Bearer';

    constructor(
        private authorizationStrategyService: AuthorizationStrategyService,
        private personalizationsService: PersonalizationsService,
        private operationService: OperationService,
        private documentService: DocumentService,
        private profile: ProfileService,
        private router: Router,
        private DeviceDetecterService: DeviceDetectorService,
        private _encoder: EncodeB64Service
    ) {
        this.authToken = this.profile.getPublicToken();
        const hasToken = this.authToken.includes(this.AUTH_KEY);
        this.isPublic = !hasToken;
        this.statusBarModel = new StatusBarModel();
    }

    public setOperationID(id: string): void {
        this.operationId = id;
    }

    public setExtraDocs(): void {
        this.extraDocs = this.documentListResponse.filter((doc) => doc.type === 2);
    }

    public setMainDocs(): void {
        this.mainDocs = this.documentListResponse.filter((doc) => doc.type === 1);
    }

    public setCircuitID(id: string): void {
        this.circuitId = id;
    }

    public setOTPCode(otp: string): void {
        this.otpCode = otp;
    }

    public setReceiverNIF(nif: string): void {
        this.receiverNIF = nif;
    }

    public setAttachedDocs(docs: IvCertCircuitDocumentP[]) {
        this.attachedDocs = docs;
    }

    public sethasNextOperation(value: boolean): void {
        this.hasNextOperation = value;
    }

    public setTermsAccepted(value: boolean): void {
        this.termsAccepted = value;
    }

    public getTermsAccepted(): boolean {
        return this.termsAccepted;
    }

    public getCurrentOperationStatus(): AvailableOperationStatus {
        return this.operationRequest?.state;
    }

    public getOperationType(): AvailableOperationTypes {
        return this.operationDetailResponse?.operationType as AvailableOperationTypes;
    }

    public getRoutePath(request?: OperationRequest): string {
        return this.authorizationStrategyService.getPath(request ?? this.operationRequest);
    }

    public acceptCustomCheckbox(value: boolean): void {
        this.customCheckbox.emit(value);
    }

    public async updateFirstAccess(): Promise<void> {
        await this.operationService.operationPutUpdateFirstAccess(this.operationId, this.authToken);
    }

    public async hasPermissionToFinishPro(hasNextOperation?: boolean): Promise<boolean> {
        const hasStrategy = true;
        await this.getOperationDetail(hasStrategy, hasNextOperation);

        await Promise.all([this.getOperationDocumentsList(hasStrategy)]);

        const availableOperations: AvailableOperationTypes[] = [
            AvailableOperationTypes.ACEP,
            AvailableOperationTypes.SIG,
            AvailableOperationTypes.SIGBIO,
            AvailableOperationTypes.RVDOTP,
            AvailableOperationTypes.DWN,
            AvailableOperationTypes.SIGQSCD,
            AvailableOperationTypes.DYNSIG,
            AvailableOperationTypes.VAL,
            AvailableOperationTypes.NOTE,
            AvailableOperationTypes.QERDS
        ];
        const { operationType } = this.operationDetailResponse || {};
        const isOperationAvailable = availableOperations?.includes(operationType as AvailableOperationTypes);
        const hasRoutePermission = isOperationAvailable;

        this.operationRequest.hasOperationSupport = hasRoutePermission;

        return hasRoutePermission;
    }

    public async getOperationDetail(hasStrategy?: boolean, hasNextOperation?: boolean): Promise<void> {
        try {
            const response: IvCertGenericResponseOperationDetailR = await this.operationService.operationGetOperationDetail(this.operationId, this.authToken);

            if (response?.data) {
                const { data } = response;
                this.operationDetailResponse = data;
                this.userId = this.profile.getUserProperty('id');
                this.ownerId = this.operationDetailResponse.idUserCreator;
                const isOwner: boolean = Number(this.userId) === Number(this.ownerId);
                const visualizeFirst: boolean = this.operationDetailResponse.visualizeClientDoc === 1 && isOwner ? true : false;
                const visualizeSecond: boolean = this.operationDetailResponse.visualizeClientDoc === 2 ? true : false;
                this.letAttachment = (visualizeFirst || visualizeSecond) && this.operationDetailResponse.operationType !== operationTypeEnum.DWN;
                this.hasCustomFields = false;
                if (this.operationDetailResponse?.CustomFields?.length > 0) {
                    this.hasCustomFields = true;
                }
                this.readAllDoc = this.operationDetailResponse.readAllDoc;
                this.isFinishPro = this.operationDetailResponse.newSignApp;
                this.validateFormDoc = this.operationDetailResponse.validateFormDoc;
                this.idCircuitCorto = this.operationDetailResponse.idCircuitCorto;
                this.internalMessages = this.operationDetailResponse?.messages;
                this.ownerId = this.operationDetailResponse?.idUserCreator;
                this.receiverId = this.operationDetailResponse?.idUserDest;
                this.fileConfig.secondaryMax = this.operationDetailResponse.numDocsClient;
                this.extensions.secondary = this.setExtensions(this.operationDetailResponse.extensionsDocsClient);
                this.customMessage = this.operationDetailResponse?.customMessage;

                this.checkCallbackOK(data.urlCallbackOK);
                this.checkCallbackKO(data.urlCallbackKO);
                this.getOperationAuthPreference();

                if (hasStrategy) {
                    this.operationRequest = new OperationRequest();
                    this.operationRequest.operationType = data.operationType as AvailableOperationTypes;
                    this.operationRequest.idCircuit = data.idCircuit;
                    this.operationRequest.offShowIntroPage = data.offIntroFinishOperation;
                    this.operationRequest.circuitName = data.circuitName;
                    this.operationRequest.idOperation = data.idOperation;
                    this.operationRequest.typeSignature = data.typeSignature;
                    this.operationRequest.hasCustomCheckbox = data?.CheckBoxConsent?.length ? true : false;
                    this.setOperationID(data.idOperation);
                    this.setCircuitID(data.idCircuit);
                    this.operationRequest.state = data.idEstado as AvailableOperationStatus;
                    this.operationRequest.hasOperationSupport = true;
                    this.operationRequest.requiredLogin = data.requiredLogin && this.authToken === '1';
                    if (data.offIntroFinishOperation) {
                        await this.getOperationDocumentsList(true);
                    }
                    if (!this.tokenSAML) {
                        this.tokenSAML = this.router.parseUrl(decodeURIComponent(this.router.url))?.queryParams['token'];
                    }

                    this.operationRequest.hasTokenSAML = !!this.tokenSAML;

                    if (this.operationRequest.hasTokenSAML) {
                        await this.getOperationDocumentsList(true);
                    }

                    this.operationRequest.automaticDownload = this.personalizationsService.environment.automaticDownload;
                    if (this.operationRequest.automaticDownload) {
                        this.operationRequest.hasFinishCircuit = true;
                    }
                    this.statusBarModel.signerName = data.nameUser;
                    this.statusBarModel.signerEmail = data.mailUser;

                    if (hasNextOperation) {
                        this.operationRequest.nextOperation = true;
                        this.operationRequest.hasFinishCircuit = false;
                    }

                    if (this.operationRequest.automaticDownload && data.operationType === AvailableOperationTypes.DWN) {
                        this.operationRequest.hasFinishCircuit = true;
                    }
                }
            }
        } catch (e) {
            this.operationRequest = new OperationRequest();
            this.operationRequest.hasError = true;
            this.operationRequest.error = e;
            console.log(e);
        }
    }

    public async getOperationDocumentsList(hasStrategy?: boolean): Promise<any> {
        try {
            const response: IvGenericRestResponseListIvCertCircuitDocumentP =
                await this.documentService.documentGetListDocumentsOperation(this.operationId, this.authToken, null);

            if (response?.data) {
                this.documentListResponse = response.data;
                this.setExtraDocs();
                this.setMainDocs();
                this.statusBarModel.signatureDocuments = response.data;

                if (hasStrategy) {
                    if (this.documentListResponse.length > 1) {
                        this.operationRequest.documentList = response.data;
                        return;
                    }
                    this.operationRequest.idDocument = this.documentListResponse[0].idDocument;
                    this.operationRequest.documentTitle = this.documentListResponse[0].title;
                }
            }
        } catch (e) {
            this.operationRequest = new OperationRequest();
            this.operationRequest.hasError = true;
            this.operationRequest.error = e;
            console.log(e);
        }
    }

    public async getDownloadDocumentCircuit(
        observe: DocumentListObserve = DocumentListObserve.BODY,
        documentId?: string,
        download?: boolean,
        isThumbnail?: boolean,
        index?: number,
        extra?: boolean
    ): Promise<Uint8Array | string> {
        return new Promise(async (resolve, reject) => {
            const idCircuit = this.operationDetailResponse?.idCircuit;
            const idDocument: string = documentId ?? this.operationRequest?.idDocument;
            const appId = this.personalizationsService.environment.appid;
            const document = this.documentListResponse?.find(res => res.idDocument === idDocument);
            const docName = extra ? this.extraDocs[index]?.fileNameWithExtension : document?.fileNameWithExtension;
            this.extension = typeof docName === 'string' ? docName.split('.').pop().toUpperCase() : (docName as { name: string })?.name?.split('.').pop().toUpperCase();

            if (documentId) {
                const selectedDoc = this.documentListResponse?.find(res => res.idDocument === idDocument);
                this.extension = selectedDoc?.fileNameWithExtension.split('.').pop().toUpperCase();
            }

            try {
                const response = await this.documentService.documentGetDownloadDocumentCircuit(
                    idCircuit,
                    idDocument,
                    this.authToken,
                    appId,
                    this.operationId,
                    isThumbnail,
                    observe as any
                );

                this.downloadDocumentResponse = response;

                if (response?.body) {
                    if (this.extension === 'PDF') {
                        const reader = new FileReader();
                        reader.readAsArrayBuffer(response.body);

                        reader.onload = () => {
                            this.documentBuffer = new Uint8Array(reader.result as ArrayBuffer);
                            resolve(this.documentBuffer);
                        };

                    } else if (this.extension === 'XML') {
                        const blb = new Blob([response?.body], { type: "text/plain" });
                        const reader = new FileReader();
                        reader.addEventListener('loadend', (e: any) => {
                            this.xml = e.target.result;
                            resolve(this.xml);
                        });
                        reader.readAsText(blb);
                    }
                    if (download) {
                        const blob = new Blob([response.body], { type: 'application/pdf' });
                        saveAs(blob, docName);
                    }
                }
            } catch (e) {
                console.log(e);
                reject();
            }
        });
    }

    public async getModifyDocumentsByType(type: number = 1) {
        let newDocuments: DocumentCircuit = [];

        for (const document of this.documentListResponse as DocumentCircuit) {
            if (document.type === type) {
                const documentExtension = document.fileNameWithExtension.split('.').pop().toLowerCase();
                const docResponse = await this.getDownloadDocumentCircuit(DocumentListObserve.RESPONSE, document.idDocument, false, false);

                if (documentExtension === 'pdf') {
                    const b64Pdf = this._encoder.arrayBufferToBase64((docResponse as Uint8Array).buffer as ArrayBuffer);
                    document.b64 = b64Pdf;
                }

                if (documentExtension === 'xml') {
                    document.b64 = this._encoder.stringToB64(docResponse as string);
                }

                document.read = true;
                newDocuments.push({ ...document });
            }
        }
        this.documentsForSign = newDocuments;

        return newDocuments;
    }

    public async getDownloadDocumentsCircuit(typeDoc?: number): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                const response: any = await this.documentService.documentGetDownloadDocumentsOperation(this.operationId, this.authToken).toPromise();
                this.downloadDocumentResponse = response;
                if (response) {
                    const filename = this.documentListResponse.length > 1 ? this.idCircuitCorto + '.zip' : this.documentListResponse[0].fileNameWithExtension;
                    FileSaver.saveAs(response, filename);
                    resolve();
                }
            } catch (e) {
                reject(e);
            }
        })
    }

    public async getOperationAuthPreference(): Promise<void> {
        try {
            const response: IvCertGenericResponseListAuthPreference = await this.operationService
                .operationGetOperationAuthPreference(this.authToken, this.operationId)
                .toPromise();
            if (response?.data) {
                this.authPreferenceResponse = response.data;
                this.operationRequest.authPreferenceResponse = !!this.authPreferenceResponse?.length;
                this.getRoutePath();
            }
        } catch (e) {
            console.log(e);
        }
    }

    public async isNextOperationClosed(): Promise<boolean> {
        const operationId = this.operationId;
        if (!operationId) return false;
        try {
            const response: IvGenericRestResponseString = await this.operationService
                .operationGetNextOperationClosed(operationId, this.authToken)
                .toPromise();
            if (response && response.Code === '200') {
                this.nextOperationResponse = response;
                return true;
            }
            return false;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    public async putFinishOperation(
        hasStrategy?: boolean,
        metadata?: Array<CustomMetadataOperation>,
        result?: boolean,
    ): Promise<void> {
        const operationId = this.operationId;
        const appId = this.personalizationsService.environment.appid;
        try {
            metadata = metadata ? [...metadata, ...(await this.getMetadata(result))] : await this.getMetadata();
            const response: IvCertGenericResponseListString = await this.operationService
                .operationPutFinishOperation(operationId, metadata as any, appId, this.authToken)
                .toPromise();
            if (response?.data) {
                this.finishOperationResponse = response.data;
                this.errorCodeRVDOTP = null;
                const hasNextOperationId = !!this.finishOperationResponse[1];

                this.sethasNextOperation(hasNextOperationId);
                const hasResultParam = result !== undefined;

                if (this.downloadOnFinish) {
                    await this.getDownloadDocumentsCircuit();
                }

                if (hasStrategy) {
                    this.operationRequest = new OperationRequest();
                    this.operationRequest.hasFinishCircuit = !hasNextOperationId;
                    this.operationRequest.state = hasResultParam
                        ? AvailableOperationStatus.DOCUMENTACION_RECHAZADA
                        : this.operationRequest.state;

                    if (hasResultParam) {
                        this.operationRequest.hasDeclineOperation = !result;
                    }

                    if (hasNextOperationId) {
                        this.showNewOperationLoader.next(true);
                        this.setOperationID(this.finishOperationResponse[1]);
                        await this.hasPermissionToFinishPro(hasNextOperationId);
                    }
                }
            }
        } catch (e) {
            this.operationRequest = new OperationRequest();
            this.operationRequest.hasError = true;
            this.operationRequest.error = e;
            this.errorEvent.emit(e.error.error.code);
            this.errorCodeRVDOTP = this.operationDetailResponse.operationType == AvailableOperationTypes.RVDOTP ? e.error.error.message : null;
            console.log(e);
        }
    }

    public async getMetadata(result: boolean = true): Promise<Array<CustomMetadataOperation>> {
        let metadata: Array<CustomMetadataOperation> = [];
        await this.getOperationMetada();

        metadata.unshift({ key: 'result', value: `${result}` });
        metadata.push({ key: 'signatureInfo', value: JSON.stringify(this.DeviceDetecterService.getDeviceInfo()) });

        if (!!this.metadataResponse.length) {
            metadata = metadata.concat(this.metadataResponse);
        }
        return metadata;
    }

    public async getOperationMetada(): Promise<void> {
        const appId = this.personalizationsService.environment.appid;
        const operationId = this.operationId;

        try {
            const response: IvCertGenericResponseListMetadataKeyOperationF = await this.operationService
                .operationGetConfigMetadaOperation(
                    this.operationDetailResponse.operationType,
                    operationId,
                    this.authToken,
                    appId
                ).toPromise();

            if (response?.data) {
                const res: MetadataKeyOperationF[] = response?.data;

                this.metadataResponse = res.map((elem: MetadataKeyOperationF) => ({
                    key: elem.idMetadato,
                    type: elem.tipoMetadato,
                    required: elem.datoObligatorio,
                    default: elem.valorDefecto,
                    value: elem.valorDefecto,
                }));
            }
        } catch (e) {
            console.log(e);
        }
    }

    public setExtensions(extensions: string): string {
        let ext = '';
        if (extensions.includes('pdf')) {
            ext += '.pdf,.PDF,';
        }
        if (extensions.includes('xml')) {
            ext += '.xml,.XML,';
        }

        return ext;
    }

    public checkCallbackOK(urlOK: string = ''): void {
        if (urlOK) this.urlCallbackOK = urlOK;
    }

    public checkCallbackKO(urlKO: string = ''): void {
        if (urlKO) this.urlCallbackKO = urlKO;
    }
}
